module.exports = __webpack_public_path__ + "media/award-apple-2018-a7bd9cdc.png";